import angular from 'angular';
import cloneDeep from 'clone-deep';
import deleteModal from './deleteModal.html';
import editModal from './editModal.html';
import uploadModal from './uploadModal.html';

/* @ngInject */
export default function (params) {
	let {
		    $scope,
		    LayoutService,
		    $stateParams,
		    toastr,
		    DataTablesService,
		    PermissionsCategories,
		    PermissionsGates,
		    PermissionsUsers,
		    PermissionsServiceUsers,
		    DocumentsDirectories,
		    DocumentsDocuments,
		    DocumentsVersions,
		    STATUSES,
		    $state,
		    moment,
		    $uibModal,
		    AuthService,
		    $timeout,
		    DocumentsService,
	    } = params;

	const getDocumentWithPermissionsAndDirectory = (documentId) => {
		return DocumentsDocuments.one(documentId)
		                         .get({
			                         include: 'permissions.user,permissions.serviceUser,directory',
		                         })
		                         .then((document) => {
			                         if (document.permissions === undefined) {
				                         document.permissions = [];
			                         }

			                         document.directory = document.directory.id;

			                         return document;
		                         });
	};

	const normalizePermissionsFromAPI = (permissions) => {
		let output = [];

		angular.forEach(permissions, (item) => {
			let permission = {
				...cloneDeep(item),
			};

			if (item.user !== undefined) {
				permission.user = item.user.id;
			} else {
				permission.user = null;
			}

			if (item.serviceUser !== undefined) {
				permission.serviceUser = item.serviceUser.id;
			} else {
				permission.serviceUser = null;
			}

			if (permission.gate !== null) {
				permission.type = 'gate';
			} else if (permission.category !== null) {
				permission.type = 'category';
			} else if (permission.user !== null) {
				permission.type = 'user';
			} else if (permission.serviceUser !== null) {
				permission.type = 'serviceUser';
			} else {
				permission.type = 'public';
			}

			output.push(permission);
		});

		return output;
	};

	const normalizePermissionsForAPI = (permissions) => {
		return permissions.filter((permission) => {
			                  if (!permission.permission) {
				                  return false;
			                  }

			                  switch (permission.type) {
				                  case 'gate': {
					                  return (permission.gate);
				                  }

				                  case 'category': {
					                  return (permission.category);
				                  }

				                  case 'user': {
					                  return (permission.user);
				                  }

				                  case 'serviceUser': {
					                  return (permission.serviceUser);
				                  }

				                  case 'public': {
					                  return true;
				                  }

				                  default: {
					                  return false;
				                  }
			                  }
		                  })
		                  .map((permission) => {
			                  let output = {
				                  ...cloneDeep(permission),
				                  gate:        null,
				                  category:    null,
				                  user:        null,
				                  serviceUser: null,
			                  };

			                  if (output.id !== undefined) {
				                  delete output.id;
			                  }

			                  switch (permission.type) {
				                  case 'gate': {
					                  output.gate = permission.gate;

					                  break;
				                  }

				                  case 'category': {
					                  output.category = permission.category;

					                  break;
				                  }

				                  case 'user': {
					                  output.user = permission.user;

					                  break;
				                  }

				                  case 'serviceUser': {
					                  output.serviceUser = permission.serviceUser;

					                  break;
				                  }

				                  default: {
					                  break;
				                  }
			                  }

			                  return output;
		                  });
	};

	const parseFile = (file) => {
		let name      = file.name;
		let extension = '';

		const extensionSeparator = file.name.lastIndexOf('.');

		if (extensionSeparator !== -1) {
			name      = file.name.substring(0, extensionSeparator);
			extension = file.name.substring(extensionSeparator + 1);
		}

		return {
			name,
			extension,
			size:     file.size,
			mimeType: file.type,
		};
	};

	$scope.documentId = null;

	$scope.document = {
		data:   null,
		status: STATUSES.UNLOADED,
	};

	$scope.documentGetIconForMimeType = (mimeType) => {
		const iconTypes = {
			directory:   'fa-folder',
			generic:     'fa-file',
			image:       'fa-file-image',
			audio:       'fa-file-audio',
			video:       'fa-file-video',
			script:      'fa-file-code',
			document:    'fa-file-alt',
			spreadsheet: 'fa-file-spreadsheet',
			archive:     'fa-file-archive',
			word:        'fa-file-word',
			pdf:         'fa-file-pdf',
			excel:       'fa-file-excel',
			powerpoint:  'fa-file-powerpoint',
		};

		let icon = iconTypes[DocumentsService.getClassicationForMimeType(mimeType)];

		const mapping = {
			'application/msword':                                                        iconTypes.word,
			'application/pdf':                                                           iconTypes.pdf,
			'application/vnd.ms-excel':                                                  iconTypes.excel,
			'application/vnd.ms-powerpoint':                                             iconTypes.powerpoint,
			'application/vnd.oasis.opendocument.presentation':                           iconTypes.powerpoint,
			'application/vnd.oasis.opendocument.spreadsheet':                            iconTypes.excel,
			'application/vnd.oasis.opendocument.text':                                   iconTypes.word,
			'application/vnd.openxmlformats-officedocument.presentationml.presentation': iconTypes.powerpoint,
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':         iconTypes.excel,
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document':   iconTypes.word,
		};

		if (mimeType) {
			angular.forEach(mapping, (value, key) => {
				if (mimeType === key) {
					icon = value;
				}
			});
		}

		return icon;
	};

	$scope.documentSelectDocument = (documentId) => {
		$scope.documentId = documentId;

		$scope.refreshDocument();
	};

	$scope.documentDeselectDocument = () => {
		$scope.document.status = STATUSES.UNLOADED;
		$scope.document.data   = null;

		$scope.documentId = null;

		$scope.documentVersionDeselectVersion();

		$scope.refreshDirectory();
	};

	$scope.documentUploadVersion = (documentId) => {
		$scope.documentVersionUploadVersion(documentId);
	};

	$scope.documentUploadDocument = (directoryId) => {
		$uibModal.open({
			animation:                  true,
			template:                   uploadModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.modalDirectory = $scope.directoriesById[directoryId];

				$scope.modalDocument = {
					name:        '',
					directory:   directoryId,
					permissions: [],
					version:     {
						version: 'Version 1',
					},
				};

				$scope.modalFile = null;

				$scope.modalShowProgress     = false;
				$scope.modalProgress         = 0;
				$scope.modalProgressUploaded = 0;

				$scope.modalAddPermission = () => {
					if ($scope.modalDocument.permissions.length > 0) {
						const lastPermission = cloneDeep($scope.modalDocument.permissions[$scope.modalDocument.permissions.length - 1]);

						$scope.modalDocument.permissions.push({
							type:        lastPermission.type,
							gate:        lastPermission.gate,
							category:    lastPermission.category,
							user:        lastPermission.user,
							serviceUser: lastPermission.serviceUser,
							permission:  '',
						});
					} else {
						$scope.modalDocument.permissions.push({
							type:        '',
							gate:        null,
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  '',
						});
					}
				};

				$scope.modalRemovePermission = (index) => {
					$scope.modalDocument.permissions.splice(index, 1);
				};

				$scope.modalResetPermission = (index) => {
					$scope.modalDocument.permissions[index] = {
						...$scope.modalDocument.permissions[index],
						gate:        null,
						category:    null,
						user:        null,
						serviceUser: null,
					};
				};

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					if ($scope.modalFile) {
						const file = parseFile($scope.modalFile);

						const document = {
							name:        $scope.modalDocument.name,
							directory:   $scope.modalDocument.directory,
							permissions: [
								...normalizePermissionsForAPI($scope.modalDocument.permissions),
							],
							version:     {
								version:   $scope.modalDocument.version.version,
								name:      file.name,
								extension: file.extension,
								fileSize:  file.size,
								mimeType:  file.mimeType,
							},
						};

						DocumentsDocuments.post(document, {
							                  include: 'latestVersion.uploadForm',
						                  })
						                  .then((returnedDocument) => {
							                  const latestVersion = returnedDocument.latestVersion;
							                  const uploadForm    = latestVersion.uploadForm;

							                  $scope.modalProgress     = 0;
							                  $scope.modalShowProgress = true;

							                  return DocumentsDocuments.uploadToStorage(uploadForm, $scope.modalFile);
						                  })
						                  .then((storageResponse) => {
							                  $uibModalInstance.close();

							                  $scope.refreshDirectory();
						                  }, (storageError) => {
							                  throw storageError;
						                  }, (storageProgressEvent) => {
							                  $scope.modalProgress         = parseInt(storageProgressEvent.loaded / storageProgressEvent.total * 100);
							                  $scope.modalProgressUploaded = storageProgressEvent.loaded;
						                  })
						                  .catch((error) => {
							                  toastr.clear();
							                  toastr.error('There was an error while uploading the document, please try again.', 'Error');

							                  $scope.modalShowProgress = false;
							                  $scope.modalProgress     = 0;
						                  });
					} else {
						toastr.clear();
						toastr.warning('You must select a file to upload.', 'Select File');
					}
				};

				$scope.$watch('modalFile', (newValue) => {
					if (newValue) {
						const {name} = parseFile(newValue);

						$scope.modalDocument.name = name;
					}
				});
			},
		});
	};

	$scope.documentEditDocument = (documentId) => {
		$uibModal.open({
			animation:                  true,
			template:                   editModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.modalDocument = null;

				$scope.modalOriginalDocument = $scope.documentsById[documentId];

				$scope.modalStatus = STATUSES.LOADING;

				getDocumentWithPermissionsAndDirectory(documentId)
					.then((document) => {
						$scope.modalDocument = {
							...cloneDeep(document),
							permissions: [
								...normalizePermissionsFromAPI(document.permissions),
							],
						};

						$scope.modalStatus = STATUSES.LOADED;
					})
					.catch((error) => {
						$scope.modalStatus = STATUSES.ERRORED;

						toastr.clear();
						toastr.error('There was an error while loading the document information, please try again.', 'Error');

						$uibModalInstance.close();
					});

				$scope.modalAddPermission = () => {
					if ($scope.modalDocument.permissions.length > 0) {
						const lastPermission = cloneDeep($scope.modalDocument.permissions[$scope.modalDocument.permissions.length - 1]);

						$scope.modalDocument.permissions.push({
							type:        lastPermission.type,
							gate:        lastPermission.gate,
							category:    lastPermission.category,
							user:        lastPermission.user,
							serviceUser: lastPermission.serviceUser,
							permission:  '',
						});
					} else {
						$scope.modalDocument.permissions.push({
							type:        '',
							gate:        null,
							category:    null,
							user:        null,
							serviceUser: null,
							permission:  '',
						});
					}
				};

				$scope.modalRemovePermission = (index) => {
					$scope.modalDocument.permissions.splice(index, 1);
				};

				$scope.modalResetPermission = (index) => {
					$scope.modalDocument.permissions[index] = {
						...$scope.modalDocument.permissions[index],
						gate:        null,
						category:    null,
						user:        null,
						serviceUser: null,
					};
				};

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					if ($scope.modalStatus === STATUSES.LOADED) {
						const document = {
							name:        $scope.modalDocument.name,
							directory:   $scope.modalDocument.directory,
							permissions: [
								...normalizePermissionsForAPI($scope.modalDocument.permissions),
							],
						};

						DocumentsDocuments.one(documentId)
						                  .customPUT(document)
						                  .then((returnedDirectory) => {
							                  $uibModalInstance.close();

							                  $scope.refreshDocument();
						                  })
						                  .catch((error) => {
							                  toastr.clear();
							                  toastr.error('There was an error while editing the document, please try again.', 'Error');

							                  $uibModalInstance.close();

							                  $scope.documentDeselectDocument();

							                  $scope.refreshDirectory();
						                  });
					} else {
						toastr.clear();
						toastr.warning('Please wait for the document information to load.', 'Loading...');
					}
				};
			},
		});
	};

	$scope.documentDeleteDocument = (documentId) => {
		$uibModal.open({
			animation:                  true,
			template:                   deleteModal,
			scope:                      $scope,
			size:                       'lg',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.modalOriginalDocument = $scope.documentsById[documentId];

				$scope.modalCancel = () => {
					$uibModalInstance.close();
				};

				$scope.modalConfirm = () => {
					DocumentsDocuments.one(documentId)
					                  .remove()
					                  .then((response) => {
						                  $uibModalInstance.close();

						                  $scope.documentDeselectDocument();

						                  $scope.refreshDirectories();
					                  })
					                  .catch((error) => {
						                  toastr.clear();
						                  toastr.error('There was an error while editing the directory, please try again.', 'Error');

						                  $uibModalInstance.close();

						                  $scope.documentDeselectDocument();

						                  $scope.refreshDirectories();
					                  });
				};
			},
		});
	};

	$scope.refreshDocument = () => {
		const populateDocumentById = (documentId) => {
			if ($scope.documentsById[documentId]) {
				let document = $scope.documentsById[documentId];

				return {
					...document,
				};
			} else {
				return null;
			}
		};

		if ($scope.documentId) {
			$scope.document.data   = populateDocumentById($scope.documentId);
			$scope.document.status = STATUSES.LOADING;

			DocumentsDocuments.one($scope.documentId)
			                  .get({
				                  include: 'versions.reviews.user.workable,latestVersion,parent',
			                  })
			                  .then((data) => {
				                  const document = data;

				                  if (document.id === $scope.documentId) {
					                  $scope.document.data   = document;
					                  $scope.document.status = STATUSES.LOADED;

					                  $scope.documentVersionSelectVersion($scope.document.data.latestVersion.id);
				                  }

				                  // Otherwise this call was for a previous document
			                  })
			                  .catch((error) => {
				                  toastr.clear();
				                  toastr.error('There was an error while loading the document manager, please try again.', 'Error');

				                  $scope.document.status = STATUSES.ERRORED;
			                  });
		}
	};
}


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/documents/root/controllers/document/index.js